import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CONSENT_KEY } from "@/lib/site";

const EVT = "v2050:cookie-prefs";

export function openCookiePreferences() {
    window.dispatchEvent(new Event(EVT));
}

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try { setVisible(!localStorage.getItem(CONSENT_KEY)); } catch { /* noop */ }
        const show = () => setVisible(true);
        window.addEventListener(EVT, show);
        return () => window.removeEventListener(EVT, show);
    }, []);

    const choose = (v) => {
        try { localStorage.setItem(CONSENT_KEY, v); } catch { /* noop */ }
        setVisible(false);
    };

    if (!visible) return null;
    return (
        <div data-testid="cookie-banner" role="dialog" aria-label="Cookie preferences"
             className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-sm z-[35] bg-ink/95 backdrop-blur-xl text-cream p-6 rounded-2xl shadow-2xl">
            <p className="text-sm leading-relaxed text-cream/85">
                We use essential cookies to run this site and, with your permission, anonymous analytics to understand which pages are useful. <Link to="/legal/cookies" className="underline hover:text-sage">Learn more</Link>.
            </p>
            <div className="mt-5 flex gap-3">
                <button type="button" onClick={() => choose("accepted")} data-testid="cookie-accept"
                        className="flex-1 rounded-full bg-cream text-forest hover:bg-sage px-4 py-2.5 text-sm font-medium transition-colors">Accept</button>
                <button type="button" onClick={() => choose("declined")} data-testid="cookie-decline"
                        className="flex-1 rounded-full border border-cream/40 hover:border-cream px-4 py-2.5 text-sm transition-colors">Essential only</button>
            </div>
        </div>
    );
}
